import React from 'react';
import MessageControl from './MessageControl';
import classNames from 'classnames';
import css from './OrdinaryMessageContent.css';
import { useMessageContext, isRelatedTargetInsideControlsPanel } from './useMessageContext';

const OrdinaryMessageContent = ({ messageContentClassName }) => {
    const {
        message,
        isOwnMessage,
        controlsPanelOpen,
        setControlsVisibility,
        isMessageDeleted,
    } = useMessageContext();

    const { attributes } = message || {};
    const { content } = attributes || {};

    const handleBlur = event => {
        if (isRelatedTargetInsideControlsPanel(event)) {
            return;
        }

        setControlsVisibility(false);
    };

    const handleMouseLeave = event => {
        if (isRelatedTargetInsideControlsPanel(event)) {
            return;
        }

        setControlsVisibility(false);
    };

    const tabProps = isMessageDeleted
        ? {}
        : {
              'aria-label': 'Chat-Nachricht',
              tabIndex: 0,
              role: 'region',
          };

    return (
        <div
            className={classNames(css.ordinaryMessageContainer, {
                [css.isOwnMessage]: isOwnMessage,
                [css.message]: !isOwnMessage,
                [css.deletedMessage]: isMessageDeleted,
            })}
            onMouseLeave={handleMouseLeave}
            onFocus={() => setControlsVisibility(true)}
            onBlur={handleBlur}
            {...tabProps}
        >
            <p className={classNames(css.ordinaryMessageContent, messageContentClassName)}>
                {content}
            </p>
            {!isMessageDeleted && (
                <MessageControl
                    rootClassName={css.messageControl}
                    controlsPanelOpen={controlsPanelOpen}
                    handleControlsVisibility={setControlsVisibility}
                />
            )}
        </div>
    );
};
export default OrdinaryMessageContent;
